const apiUrl = "https://api.autographamt.com/"

// const apiUrl = "http://localhost:8000/"

// const apiUrl = "http://127.0.0.1:8000/"

export default apiUrl
